// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const cloyster: PokeData = {
  "id": 91,
  "name": "cloyster",
  "height": 15,
  "weight": 1325,
  "base_experience": 184,
  "types": [
    PokeType.WATER,
    PokeType.ICE
  ],
  "api_moves": [
    "tackle",
    "twineedle",
    "leer",
    "supersonic",
    "water-gun",
    "hydro-pump",
    "ice-beam",
    "aurora-beam",
    "withdraw",
    "barrier",
    "clamp",
    "spike-cannon",
    "protect",
    "spikes",
    "whirlpool",
    "icicle-spear",
    "iron-defense",
    "toxic-spikes",
    "ice-shard",
    "shell-smash",
    "razor-shell",
    "icicle-crash"
  ],
  "moves": [
    "tackle",
    "leer",
    "supersonic",
    "hydro-pump",
    "protect",
    "whirlpool",
    "toxic-spikes",
    "ice-shard",
    "blizzard",
    "chilly-reception",
    "life-dew",
    "rain-dance",
    "aurora-veil"
  ],
  "evolution_chain": {
    "id": 39,
    "item": null,
    "species": [
      {
        "name": "shellder",
        "order": 98,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "cloyster",
        "order": 99,
        "types": [
          PokeType.WATER,
          PokeType.ICE
        ],
        "evolves_from_species_id": 90,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "water-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 132,
    "speed": 114,
    "ability_power": 154
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
